import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';

const PageSkeleton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const waitToLoad = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(waitToLoad);
  }, []);

  return (
    show && (
      <Container sx={{ mt: 2 }}>
        <Skeleton variant="text" animation="wave" sx={{ fontSize: '2em' }} />
        <Skeleton
          variant="text"
          animation="wave"
          sx={{ fontSize: '1.5em' }}
          width={300}
        />
        <Skeleton variant="rounded" animation="wave" height={200} />
        <Box sx={{ mt: 2 }}>
          <Skeleton
            variant="text"
            animation="wave"
            width={300}
            sx={{ fontSize: '1.5em' }}
          />
          <Skeleton variant="rounded" animation="wave" height={200} />
        </Box>
      </Container>
    )
  );
};

export default PageSkeleton;
